import client from './client';

export interface Report {
  id: string;
  number: number;
  category: string;
  message: string;
  status: string;
  adminResponse?: string;
  userComment?: string;
  createdAt: string;
}

export async function sendReport(category: string, message: string): Promise<Report> {
  const { data } = await client.post('/reports', { category, message });
  return data;
}

export async function getMyReports(): Promise<Report[]> {
  const { data } = await client.get('/reports');
  return data || [];
}

export async function resolveReport(id: string) {
  const { data } = await client.post(`/reports/${id}/resolve`);
  return data;
}

export async function reopenReport(id: string, comment: string) {
  const { data } = await client.post(`/reports/${id}/reopen`, { comment });
  return data;
}
